export default __webpack_public_path__ + "static/media/lato-black.da43c06d.eot";